import React from 'react';
import { statusChipClass, statusLabel } from '../../constants/theme';

const StatusChip = ({ status }) => {
  const cls = statusChipClass[status] ?? 'chip-gray';
  const label = statusLabel[status] ?? status?.replace(/_/g, ' ') ?? '—';
  return <span className={cls}>{label}</span>;
};

export default StatusChip;
